import { render, staticRenderFns } from "./ModalTruckingInvoiceDiscount.vue?vue&type=template&id=7cdea177&"
import script from "./ModalTruckingInvoiceDiscount.vue?vue&type=script&lang=ts&"
export * from "./ModalTruckingInvoiceDiscount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cdea177')) {
      api.createRecord('7cdea177', component.options)
    } else {
      api.reload('7cdea177', component.options)
    }
    module.hot.accept("./ModalTruckingInvoiceDiscount.vue?vue&type=template&id=7cdea177&", function () {
      api.rerender('7cdea177', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TruckingAccountReceivable/ModalTruckingInvoiceDiscount.vue"
export default component.exports